/**
 * AuthContent - Form switcher based on current auth mode
 */
import React from 'react';
import { useAuthContext } from '../../context/AuthContext';
import { AUTH_MODES } from '../../types';
import {
  LoginForm,
  OtpVerifyForm,
  PasswordLoginForm,
  SetPasswordForm,
  RegistrationForm,
  ForgotPasswordForm,
  ResetPasswordForm,
} from '../forms';

function AuthContent() {
  const { mode } = useAuthContext();
  
  const renderForm = () => {
    switch (mode) {
      case AUTH_MODES.LOGIN:
        return <LoginForm />;
        
      case AUTH_MODES.SIGNUP:
        return <LoginForm />;
        
      case AUTH_MODES.OTP_VERIFY:
        return <OtpVerifyForm />;
        
      case AUTH_MODES.PASSWORD_LOGIN:
        return <PasswordLoginForm />;
        
      case AUTH_MODES.SET_PASSWORD:
        return <SetPasswordForm />;
        
      case AUTH_MODES.REGISTRATION_FORM:
        return <RegistrationForm />;
        
      case AUTH_MODES.FORGOT_PASSWORD:
        return <ForgotPasswordForm />;
        
      case AUTH_MODES.RESET_PASSWORD:
        return <ResetPasswordForm />;
        
      default:
        return <LoginForm />;
    }
  };
  
  return (
    <div className="min-h-0 overflow-y-auto">
      {renderForm()}
    </div>
  );
}

export default AuthContent;
